import React from "react";
import "./StatusCard.css";
import forward from "../../images/shapes/Forward.png";

const StatusCard = ({ img, value, label, bgColor, bgColor1, onClick }) => {
  return (
    <div
      style={{
        background: bgColor,
        padding: "16px",
        borderRadius: "17.6px",
        flex: 1,
        cursor: onClick ? "pointer" : "default", // Add cursor pointer if clickable
      }}
      className="statuscard1"
      onClick={onClick} // Add onClick handler
    >
      <div className="card-content">
        <span className="icon-container" style={{ background: bgColor1 }}>
          <img src={img} alt="status icon" className="icon" />
        </span>
        <div className="card-details1">
          <h3>{value}</h3>
          <p>{label}</p>
        </div>
        <span className="forward-icon">
          <img src={forward} alt="forward" />
        </span>
      </div>
    </div>
  );
};

export default StatusCard;